export const shortAddress = (address = "", width = 4): string => {
  if (!address) return "";

  return `${address.slice(0, width + 2)}...${address.slice(-width)}`;
};
